import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../utils/authSession';

const GuestRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  if (isAuthenticated()) return <Navigate to="/home" replace />;
  return children;
};

export default GuestRoute;
